import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'

import pages from './pages'
import menu from './menu'
import customposts from './customposts'
import loader from './loader'
import siteinfo from './siteinfo'
import thumb from './thumb'
import categories from './categories'
import video from './video'
import filtercats from './filtercats'
import siteoptions from './siteoptions'

export default combineReducers({
  router: routerReducer,
  pages,
  menu,
  customposts,
  loader,
  siteinfo,
  thumb,
  categories,
  video,
  filtercats,
  siteoptions,
})


// WEBPACK FOOTER //
// ./src/reducers/index.js